import React from 'react';
import { useProductStore } from '../../ProductProvider';
import Banner from './components/Banner';
import PowerSolution from './components/PowerSolution';
import TabImgs from './components/TabImgs';
import OnePicture from './components/OnePicture';
import TabSwiper from './components/TabSwiper';
import CompareSelector from './components/CompareSelector';
import PowerWorld from './components/PowerWorld';
import Screen1 from './components/Screen1';
import Screen2 from './components/Screen2';
import Screen3 from './components/Screen3';
import Screen4 from './components/Screen4';
import Screen5 from './components/Screen5';
import EarlyBird from './components/EarlyBird';
import TC from './components/TC';

const EU_Product: React.FC = ({}) => {
    const { pageStatus } = useProductStore();

    return (
        <>
            <Banner />
            <EarlyBird endTime={new Date('2025/09/01 15:00:00 GMT+8').getTime()} />
            <PowerSolution />
            <TabImgs />
            <OnePicture />
            <Screen1 />
            <Screen2 />
            <Screen3 />
            <Screen4 />
            <Screen5 />
            <TabSwiper />
            <CompareSelector />
            <PowerWorld />
            <TC />
        </>
    );
};
export default EU_Product;
